export default function HWY_GiftSet() {
  var data = {};

  const selectors = {
    step1: ".page-step-1",
    step2: ".page-step-2",
    step3: ".page-step-3",
    loading: ".load-more-waiting",
    stepPage: ".gift-set-step-page .select-page",
    finalStep: ".gift-set-step-page .final-step",
    hideClass: "hidden-page",
    btnSelected: ".select-page .step-section .selected-button", //'.select-page .selected-button',
    btnBackToGift: ".final-step .back-to-gift",
    btnBackStep: ".select-page .back-step",
  };

  this.init = () => {
    if (!document.querySelector(".gift-set-step-page")) {
      return;
    }
    selectedItems();
    addCartGiftSet();
    jQuery(selectors.btnBackToGift).click(function () {
      jQuery(selectors.stepPage + selectors.step3).removeClass(
        selectors.hideClass
      );
      jQuery(selectors.finalStep).addClass(selectors.hideClass);
    });
    jQuery(selectors.btnBackStep).click(function () {
      let backClass = jQuery(this).data("back");
      let current = jQuery(this).data("current");
      jQuery(selectors.stepPage).addClass(selectors.hideClass);
      jQuery(selectors.stepPage + "." + backClass).removeClass(
        selectors.hideClass
      );
      delete data[current];
      processItems();
    });
  };

  const selectedItems = () => {
    if (document.querySelector(".gift-set-step-page")) {
      jQuery(selectors.btnSelected).click(function () {
        var item = jQuery(this).closest(".select-page").data("item");
        var slug = jQuery(this).data("slug");
        var price = Number(jQuery(this).data("price"));
        var title = jQuery(this).data("title");
        var image = jQuery(this).data("image");
        var id = jQuery(this).data("id");
        var variant = jQuery(this).data("variant");

        data[item] = { id, item, slug, price, title, image, variant };
        processItems();
        renderFinalHTML();
        animateScroll();
      });
    }
  };

  const processItems = () => {
    if (document.querySelector(".select-page")) {
      let percent =
        (Object.keys(data).length / Number(jQuery(".select-page").length)) *
        100;
      jQuery(".step-process-item").css("width", percent + "%");
      if (Object.keys(data).length > 0) {
        jQuery(selectors.btnSelected).removeClass("selected");
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            const element = data[key];
            jQuery(
              ".select-page." +
                key +
                ' button[data-slug="' +
                element.slug +
                '"]'
            ).addClass("selected");
          }
        }
      }
    }
  };

  const renderFinalHTML = () => {
    let listProduct = "";
    let price = 0;
    let _length = Object.keys(data).length;
    if (3 === _length) {
      jQuery(selectors.stepPage).addClass(selectors.hideClass);
      jQuery(selectors.finalStep).removeClass(selectors.hideClass);
    } else {
      jQuery(selectors.stepPage).addClass(selectors.hideClass);
      if (1 === _length) {
        jQuery(selectors.stepPage + selectors.step2).removeClass(
          selectors.hideClass
        );
      } else if (2 === _length) {
        jQuery(selectors.stepPage + selectors.step3).removeClass(
          selectors.hideClass
        );
      } else {
        jQuery(selectors.stepPage + selectors.step1).removeClass(
          selectors.hideClass
        );
      }
      jQuery(selectors.finalStep).addClass(selectors.hideClass);
    }

    let imageGroup = "";
    if (_length > 0) {
      for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {
          const element = data[key];
          listProduct += "<h5>" + element.title + "</h5>";
          price += Number(element.price);
          imageGroup +=
            '<div class="image-item"><img src="' +
            element.image +
            '" alt="' +
            element.title +
            '"></div>';
          jQuery(selectors.stepPage + " .back-step").removeClass(
            selectors.hideClass
          );
        }
      }

      jQuery(".gift-set-step-page .list-name").html(listProduct);
      jQuery(".gift-set-step-page .total-price").html("$" + price);
      jQuery(".gift-set-step-page .group-image").html(imageGroup);
    }
  };

  const addCartGiftSet = () => {
    if (document.querySelector(".final-content")) {
      jQuery(".final-content .add-cart-gift-set .add-giftset-cart").click(
        function () {
          let background = jQuery(this).data("background");
          createGiftSetBundle(background);
        }
      );
    }
  };

  const animateScroll = () => {
    var body = jQuery("html, body");
    body.stop().animate({ scrollTop: 0 }, 800, "swing", function () {});
  };

  const controlLoading = (status) => {
    if ("open" === status) {
      document.querySelector(selectors.loading).classList.add("loading");
      document.querySelector(".notification").classList.add("show");
    } else {
      document.querySelector(selectors.loading).classList.remove("loading");
      document.querySelector(".notification").classList.remove("show");
    }
  };

  const renderAPIData = () => {
    var apiData = {
      price: 0,
      images: [],
      bundleItems: [
        {
          productVariantId: "17c109ca-1695-44fa-a282-d8748dd4d2e5",
          quantity: 1,
        },
      ],
      titles: ["Gift Box "],
    };

    let price = 0;
    let _length = Object.keys(data).length;
    if (_length > 0) {
      let i = 1;
      for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {
          const element = data[key];
          price += Number(element.price);
          apiData.bundleItems.push({
            productVariantId: element.variant,
            quantity: 1,
          });

          apiData.images.push({
            sortOrder: i + 1,
            src: element.image,
          });

          apiData.titles.push(element.title);
        }

        apiData.price = price;
        i++;
      }
    }
    return apiData;
  };

  const createGiftSetBundle = (background) => {
    let apiData = renderAPIData();
    jQuery.ajax({
      type: "GET",
      dataType: "json",
      url: theme_object.ajax_url,
      data: {
        apiData,
        background,
        action: "create_gift_set_bundle",
      },
      beforeSend: function () {
        controlLoading("open");
      },
      success: function (response) {
        if (200 == response.code) {
          let addToCartUrl =
            window.location.origin +
            window.location.pathname +
            "?addToCart=" +
            response.sku;
          window.location.href = addToCartUrl;
        } else {
          console.log("Can't create bundle by API");
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log("The following error occured: " + textStatus, errorThrown);
      },
    });
  };
}
